<div class="flex-fill d-flex flex-column card p-1">
  @if (false) {
    <div>
      <dx-form [formData]="filter" [colCount]="3" (onEditorEnterKey)="getData()" appAutofocusForm="companyName">
        <dxi-item itemType="group" [colSpan]="2" [colCount]="4">
          <dxi-item dataField="companyName"></dxi-item>
          <dxi-item dataField="firstName"></dxi-item>
          <dxi-item dataField="lastName"></dxi-item>
          <dxi-item dataField="billCity" [label]="{ text: 'City' }"></dxi-item>
        </dxi-item>
        <dxi-item [colSpan]="3">
          <div *dxTemplate class="btn-toolbar justify-content-end align-items-center">
            @if (products) {
              <div class="me-3">{{ products.length }} {{ products.length === 1 ? "item found" : "items found" }}</div>
            }
            <button type="button" accesskey="s" (click)="getData()" class="btn btn-primary me-1">Search</button>
            <button type="button" (click)="clear()" class="btn btn-light">Clear</button>
          </div>
        </dxi-item>
      </dx-form>
    </div>
  }
  <div class="d-flex flex-fill flex-column">
    <dx-data-grid #dataGrid keyExpr="id" class="flex-fill d-flex flex-column" [dataSource]="products" (onRowDblClick)="rowDoubleClick($event)">
      <dxi-column dataField="id" width="100"></dxi-column>
      <!-- <dxi-column dataField="type.name" caption="Type" width="100"></dxi-column> -->
      <dxi-column dataField="partNumber" caption="Name" width="175" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="description" width="175"></dxi-column>
      <dxi-column dataField="category.name" caption="Category" width="100"></dxi-column>
      <dxi-column dataField="mixStrength.name" caption="Mix Strength" width="110"></dxi-column>
      <dxi-column dataField="material.name" caption="Material" width="100"></dxi-column>
      <dxi-column dataField="location.name" caption="Location" width="100"></dxi-column>
      <dxi-column dataField="cost" width="125" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <dxi-column dataField="basePrice" width="125" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <dxi-column dataField="shrinkPercentage" width="125"></dxi-column>
      <dxi-column dataField="inventoryUom.abbreviation" caption="Inventory UoM" width="125"></dxi-column>
      <dxi-column dataField="priceUom.abbreviation" caption="Price UoM" width="125"></dxi-column>
      <dxi-column dataField="notes" width="175"></dxi-column>
      <dxi-column></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        @if (cell.data) {
          <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
        }
      </div>

      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-search-grid"></dxo-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-success me-2" (click)="open()">Add</button>
        <button
          class="btn btn-sm btn-primary me-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Open
        </button>
        <button
          class="btn btn-sm btn-danger me-4"
          (click)="delete(dataGrid.instance.getSelectedRowsData())"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Delete
        </button>
        <!-- <button class="btn btn-sm btn-primary" (click)="editType(dataGrid.instance.getSelectedRowsData())" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
        Edit Type
      </button> -->
    </div>
    <div *dxTemplate="let data of 'toolbarText'">
      @if (products) {
        <span class="me-3">
          <strong>
            {{ dataGrid.instance.totalCount() + " items" }}
            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
          </strong>
        </span>
      }
    </div>
  </dx-data-grid>
</div>
</div>
